import { supabase } from '../lib/supabase';
import type { CampaignService, CampaignServiceInsert, CampaignServiceUpdate } from '../types/serviceProvider';
import { createCrudService } from '../lib/createCrudService';

const crud = createCrudService<CampaignService, CampaignServiceInsert, CampaignServiceUpdate>(
  'campaign_services',
  { stampUpdatedAt: false }
);

export const campaignServiceService = {
  ...crud,

  async getByCampaign(campaignId: string): Promise<CampaignService[]> {
    const { data, error } = await supabase
      .from('campaign_services')
      .select('*')
      .eq('campaign_id', campaignId)
      .order('display_order', { ascending: true })
      .order('created_at', { ascending: true });

    if (error) throw error;
    return data || [];
  },

  async getByServiceProvider(serviceProviderId: string): Promise<CampaignService[]> {
    const { data, error } = await supabase
      .from('campaign_services')
      .select('*')
      .eq('service_provider_id', serviceProviderId)
      .order('created_at', { ascending: false });

    if (error) throw error;
    return data || [];
  },
};
